import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, CheckCircle2, Sparkles, Inbox, Mail, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const cards = stats ? [
    { label: "Active talents", value: stats.talents, icon: Users },
    { label: "Published", value: stats.published, icon: CheckCircle2 },
    { label: "AI voices", value: stats.ai_voices, icon: Sparkles },
    { label: "New casting", value: stats.casting_new, icon: Inbox },
    { label: "New messages", value: stats.contact_new, icon: Mail },
  ] : [];

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold">Dashboard</h1>
      <p className="mt-1 text-sm text-zinc-500">Manage your voice catalogue, demos and enquiries.</p>
      <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-5">
        {cards.map((c) => (
          <div key={c.label} className="rounded-xl border border-zinc-200 bg-white p-5">
            <c.icon size={20} className="text-brand-violet" />
            <div className="mt-3 font-heading text-3xl font-black">{c.value}</div>
            <div className="text-xs font-semibold uppercase tracking-wide text-zinc-500">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="mt-8 grid gap-4 md:grid-cols-2">
        <Link to="/admin/talents" className="flex items-center justify-between rounded-xl border border-zinc-200 bg-white p-6 hover:border-brand-violet">
          <div><h3 className="font-heading font-bold">Manage voices</h3><p className="text-sm text-zinc-500">Add, edit, publish, feature and upload demos.</p></div>
          <ArrowRight className="text-brand-violet" />
        </Link>
        <Link to="/admin/inbox" className="flex items-center justify-between rounded-xl border border-zinc-200 bg-white p-6 hover:border-brand-violet">
          <div><h3 className="font-heading font-bold">Enquiries</h3><p className="text-sm text-zinc-500">Review casting requests and contact messages.</p></div>
          <ArrowRight className="text-brand-violet" />
        </Link>
      </div>
    </div>
  );
}
